import 'primeflex/primeflex.css';

import { ReactNode } from 'react';
import { InfoIcon } from '../icons';
import { confirmGeneric, ConfirmGenericTitle } from './confirmGeneric';
import { Description } from './styled';

type TProps = {
  caption: string;
  description: ReactNode;
  rejectLabel?: string | undefined;
  onReject?: any | undefined;
};

export const confirmInfo = ({ caption, description, rejectLabel, onReject }: TProps) => {
  return confirmGeneric({
    contents: (
      <>
        <InfoIcon />
        <ConfirmGenericTitle>{caption}</ConfirmGenericTitle>
        <Description>{description}</Description>
      </>
    ),
    rejectLabel: rejectLabel || 'Close',
    onConfirm: () => {},
    onReject: onReject,
    infoOnly: true,
  });
};
